module.exports = __webpack_public_path__ + "img/sq5d_02.2f8c79f7.jpg";